var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFilter = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M0,0H20m0,20H0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M6.256,5.5h7.486L9.991,10.225ZM4.2,5.207C5.709,7.15,8.5,10.75,8.5,10.75v4.5A.752.752,0,0,0,9.25,16h1.5a.752.752,0,0,0,.749-.75v-4.5s2.785-3.6,4.3-5.543A.748.748,0,0,0,15.2,4H4.788A.748.748,0,0,0,4.2,5.207Z",
  transform: "translate(0)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M0,0H20V20H0Z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter.9063bc2a.svg";
export { ForwardRef as ReactComponent };